// Formatters

import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
momentDurationFormatSetup(moment);

export function timeRange(start, end) {
    return `${timeFormat(start)} - ${timeFormat(end)}`;
}

export function dateTimeRange(start, end) {
    return moment(start).format('M/D/YYYY ') + timeRange(start, end);
}

export function dateLongFormat(dt) {
    var m = moment(dt);
    return m.format('MMMM D, YYYY');
}

export function dateShortFormat(dt) {
    var m = moment(dt);
    return m.format('M/D/YYYY');
}

export function timeFormat(dt) {
    var m = moment(dt);
    return m.format(m.minutes() > 0 ? 'h:mma' : 'ha');
}

export function durationFormat(text) {
    var dur = moment.duration(text);
    return dur > 0 ? dur.format('h [hr] m [min]', {trim: 'all'}) : 'None';
}